module.exports = __webpack_public_path__ + "images/icon/icon_16x16_fill_view_block-da9abc3d.svg";